module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container row",
    attrs: {
      "id": "video-archives"
    }
  }, [_c('app-navigation'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.videosByCategory), function(videos, categoryId) {
    return _c('div', {
      staticClass: "category row"
    }, [_c('app-category', {
      attrs: {
        "videos": videos,
        "categoryId": categoryId
      }
    })], 1)
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-archives-title-wrapper"
  }, [_c('h4', {
    staticClass: "video-archives-title"
  }, [_vm._v("VIDEO ARCHIVES")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c07ceb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoArchives.vue
// module id = 80
// module chunks = 0